import { render, staticRenderFns } from "./B2bInvoice.vue?vue&type=template&id=534a500f&scoped=true&"
import script from "./B2bInvoice.vue?vue&type=script&lang=js&"
export * from "./B2bInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534a500f",
  null
  
)

export default component.exports